import Header from "../components/Header"
import Footer from "../components/Footer"
export default function AboutPage() {
  
  return (
    <div className="min-h-screen bg-white">
      <Header scrollThreshold={400} />
      {/* Hero Section */}
      <section className="relative text-white overflow-hidden pt-[60px] font-titillium
      bg-[url('@/assets/images/about-banner.png')] h-[440px] bg-cover bg-cover bg-center bg-no-repeat">
        {/* Geometric Background Pattern */}
        <div className="absolute inset-0">
          
        </div>

        {/* Hero Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 h-full flex items-center">
          <div>
            <h1 className="text-[48px] font-bold text-white leading-tight mb-[12px]">
              Elevate Your Fintech Journey with iData
            </h1>
            <p className="text-[20px] leading-relaxed">
              From data to insights, unlock the depth and breadth of data
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-[40px] text-[#161616] mb-[40px]">About iData</h2>

          <div className="space-y-16">
            {/* Global Data Services */}
            <div>
              <h3 className="text-[22px] font-bold text-[rgba(22,22,22,0.85)] mb-[8px]">Global Data Services</h3>
              <p className="text-[16px] text-[#4D4D4D] leading-relaxed text-lg">
                We offer seamless access to data from different regions, ensuring that our clients can expand their
                horizons and make strategic moves in international markets. Our global data services are not only about
                providing data but also about interpreting and contextualizing it for our clients, making it easier for
                them to understand and utilize in their business operations.
              </p>
            </div>

            {/* Premier Fintech Data Partner */}
            <div>
              <h3 className="text-2xl font-semibold text-gray-900 mb-[8px]">
                iData: Your Premier Fintech Data Partner in the US
              </h3>
              <p className="text-gray-600 leading-relaxed text-lg">
                iData stands at the forefront of the Fintech industry in the United States, dedicated to revolutionizing
                the data landscape for businesses worldwide. As a leading provider of data - related solutions, we have
                carved a niche for ourselves in the highly competitive world of financial technology. We cater to a
                diverse range of clients within the financial and investment sectors. Our target clients include hedge
                funds, quantitative researchers, asset managers and other financial institutions.
              </p>
            </div>

            {/* Core Business */}
            <div>
              <h3 className="text-2xl font-semibold text-gray-900 mb-[8px]">Our Core Business: Data Provision</h3>
              <p className="text-gray-600 leading-relaxed text-lg">
                At iData, our primary offering is data. We understand that in today's data - driven economy, access to
                high - quality, relevant data is the key to making informed business decisions. Our data products are
                sourced from a vast network of reliable channels. We offer a wide range of data types, including market
                trends, financial market data, and industry - specific insights. Whether you need historical data for in
                - depth analysis or real - time data for immediate decision - making, iData has you covered.
              </p>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  )
}
